<script setup lang="ts">
import { provide, ref, onMounted, onBeforeUnmount, computed } from 'vue'
import BaseChart from '@/charts/BaseChart.vue'

const props = defineProps<{
	  data?: { date: string; count: number }[]
}>()

const chartOptions = computed(() => ({
	  tooltip: {
		      trigger: 'axis',
		      axisPointer: {
			            type: 'shadow'
			          }
		    },
	  grid: {
		      left: '3%',
		      right: '4%',
		      bottom: '3%',
		      containLabel: true
		    },
	  xAxis: {
		      type: 'category',
		      data: props.data?.map(item => item.date) || [],
		      axisTick: {
			            alignWithLabel: true
			          }
		    },
	  yAxis: {
		      type: 'value',
		      name: 'Uploads'
		    },
	  series: [
		      {
			            name: 'Daily Uploads',
			            type: 'bar',
			            barWidth: '60%',
			            data: props.data?.map(item => item.count) || [],
			            itemStyle: {
					            color: '#3b82f6'
					          }
			          }
		    ]
}))
console.log(chartOptions.value)
</script>

<template>
	  <BaseChart :options="chartOptions" class="h-full w-full" />
</template>
